import { TFunction } from "i18next";

import { StakeholderRoleEnum } from "src/core/constants/folder";

export const getStakeholderRoleOptions = (t: TFunction) =>
  Object.entries(StakeholderRoleEnum).map(([key, value]) => ({
    id: value,
    label: t(`enum.stakeholdersType.${key}`),
  }));
